import React from 'react';
import { FadeIn } from './FadeIn';
export function TableOfContents() {
  const contents = [{
    chapter: 'El Sistema SOS Natural',
    benefit: 'Saber exactamente qué comprar y cómo usarlo'
  }, {
    chapter: 'Capítulo de Rodillas y Espalda',
    benefit: "Caminar sin ese 'nudo' matutino en 7 días"
  }, {
    chapter: 'El Sueño de los Justos',
    benefit: 'Dormir 8 horas seguidas sin pastillas PM'
  }, {
    chapter: 'Digestión de Hierro',
    benefit: 'Comer en familia sin miedo a la pesadez'
  }, {
    chapter: 'La Rutina de Oro de 5 Minutos',
    benefit: 'Un plan diario simple que realmente se cumple'
  }, {
    chapter: 'Lista de Compras SOS',
    benefit: 'Nombres en inglés Y español para el súper'
  }, {
    chapter: 'Glosario Bilingüe',
    benefit: 'Nunca más confundirse en la tienda'
  }];
  return <section className="py-20 px-6 max-w-4xl mx-auto" data-id="element-206">
      <FadeIn data-id="element-207">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-brown-dark mb-12" data-id="element-208">
          ¿Qué Encontrará Dentro?
        </h2>

        <div className="grid gap-4 md:gap-6" data-id="element-209">
          {contents.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-210">
              <div className="flex flex-col md:flex-row items-start md:items-center p-6 bg-white rounded-2xl shadow-sm border border-cream-dark hover:border-amber/30 hover:shadow-md transition-all group" data-id="element-211">
                <div className="flex items-center mb-3 md:mb-0 md:w-1/2" data-id="element-212">
                  <span className="text-2xl mr-4 group-hover:scale-110 transition-transform" data-id="element-213">
                    📖
                  </span>
                  <h3 className="text-lg font-bold text-brown-dark" data-id="element-214">
                    {item.chapter}
                  </h3>
                </div>
                <div className="md:w-1/2 md:pl-6 md:border-l border-cream-dark flex items-start" data-id="element-215">
                  <span className="text-xl mr-3 text-amber" data-id="element-216">💡</span>
                  <p className="text-lg text-brown" data-id="element-217">{item.benefit}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </FadeIn>
    </section>;
}